import { TicketImageInterface } from "../common/interfaces";
import api from "./api";

export async function uploadTicketImages(
  ticketId: number,
  files: File[]
): Promise<TicketImageInterface[]> {
  const formData = new FormData();
  files.forEach((file) => formData.append("images", file));

  const { data } = await api.post(`/ticket/${ticketId}/images`, formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return data;
}

export async function listTicketImages(
  ticketId: number
): Promise<TicketImageInterface[]> {
  const { data } = await api.get(`/ticket/${ticketId}/images`);
  return data;
}

export async function deleteTicketImage(
  ticketId: number,
  ticketImageId: number
): Promise<void> {
  await api.delete(`/ticket/${ticketId}/images/${ticketImageId}`);
}
